module.exports = __webpack_public_path__ + "static/media/masjid.f6c1ba51.jfif";